import { styled } from '@/stitches.config';

import { ReactComponent as HelixLogo } from '@assets/helix.svg';

export const StyledLogo = styled(HelixLogo, {
  height: '500px',
  width: '500px',
});
